import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import SmsIcon from '@material-ui/icons/Sms';
import messages from '../../services/db/messages/messages';
import MessageItem from './MessageItem';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Scrollbar from '../Scrollbar';
import IntlMessages from '../../utility/IntlMessages';
import Hidden from '@material-ui/core/Hidden';
import {Fonts} from '../../../shared/constants/AppEnums';
import styled from 'styled-components';

const StyledIconButton = styled(IconButton)`
      justify-content: 'flex-start',
      width: 100%;
      height: 56px;
      font-size: 16px;
      border-radius: 0;
      padding-left: 1rem;
      padding-right: 1rem;
      color: theme.palette.grey[800];
      &:hover, &:focus {
        color: theme.palette.text.primary;
        background-color: transparent;
      }
      ${(props) => [props.theme.breakpoints.up('sm')]} {
        height: 70px;
      }
      ${(props) => [props.theme.breakpoints.up('md')]}{ 
        justify-content: center;
        width: auto;
        border-left: solid 1px;
        border-color: theme.palette.grey[200];
        color: theme.palette.grey[400];
        &:hover, &:focus {
          color: theme.palette.text.primary;
          background-color: theme.palette.btn.hover;
        }
      }
      ${(props) => [props.theme.breakpoints.up('lg')]} {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
      ${(props) => [props.theme.breakpoints.up('xl')]} {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
      }
      
    .badgeStyle {
      margin-right: 8px;
    }

    .smsIcon {
      font-size: 22px;
      color: ${(props) => props.theme.palette.grey[400]};
      ${(props) => [props.theme.breakpoints.up('xl')]} {
        font-size: 30px;
      }
    }
`;

const StyledPopover = styled(Popover)`
  & .MuiPopover-paper {
    width: 260px;
    ${(props) => [props.theme.breakpoints.up('sm')]} {
      width: 300px;
    }
    ${(props) => [props.theme.breakpoints.up('xl')]} {
      width: 380px;
    }
  }
  & .scroll-submenu {
    max-height: 200px;
    ${(props) => [props.theme.breakpoints.up('xl')]} {
      max-height: 380px;
    }
  }

  .btnPopover {
    border-radius: 0;
    width: 100%;
    text-transform: capitalize;
  }
  .listStyle {
    padding-left: 20px;
    padding-right: 20px;
  }
  .listroot: {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const HeaderMessages = (props) => {
  const [anchorMessages, setAnchorMessages] = React.useState(null);

  const onClickMessagesButton = (event) => {
    setAnchorMessages(event.currentTarget);
  };

  return (
    <>
      <StyledIconButton
        className='notiBtn'
        aria-label='show 4 new mails'
        color='inherit'
        onClick={onClickMessagesButton}>
        <Badge
          className='badgeStyle'
          badgeContent={messages.length}
          color='secondary'>
          <SmsIcon className='smsIcon' />
        </Badge>
        <Hidden mdUp>
          <Box ml={4} fontSize={16} color='text.secondary' component='span'>
            <IntlMessages id='dashboard.messages' />
          </Box>
        </Hidden>
      </StyledIconButton>

      <StyledPopover
        anchorEl={anchorMessages}
        id='app-message'
        open={Boolean(anchorMessages)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMessages(null)}>
        <Box>
          <Box px={5} py={3}>
            <Box component='h5' fontFamily={Fonts.LIGHT}>
              <IntlMessages id='dashboard.messages' />({messages.length})
            </Box>
          </Box>
          <Scrollbar className='scroll-submenu'>
            <List
              className='listroot'
              onClick={() => {
                setAnchorMessages(null);
              }}>
              {messages.map((item, index) => (
                <MessageItem  key={item.id} item={item} />
              ))}
            </List>
          </Scrollbar>
          <Box mt={2}>
            <Button className='btnPopover' variant='contained' color='primary'>
              <IntlMessages id='common.viewAll' />
            </Button>
          </Box>
        </Box>
      </StyledPopover>
    </>
  );
};

export default HeaderMessages;
